import { LockOutlined } from '@ant-design/icons'
import cx from 'classnames'

const Lock = ({ className, ...props }: any) => {
  return <LockOutlined className={cx('tb-icon-lock', className)} {...props} />
}

export default Lock
